<template>
  <footer class="footer-component">
    <div class="footer-content">
      <p>Copyright © 2026杭州小缘文化科技有限公司出品 - 版权所有</p>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'FooterComponent'
}
</script>

<style scoped lang="scss">
/* 使用全局样式中定义的 CSS 变量 */
.footer-component {
  background-color: var(--bg-200);
  color: var(--text-200);
  padding: 10px 0;
  text-align: center;
  border-top: 1px solid var(--border);
  margin-top: auto;
  box-shadow: var(--shadow-sm);
}

.footer-content {
  max-width: 100%;
  margin: 0 auto;
  padding: 0 20px;
}

/* 电脑端样式 */
@media (min-width: 769px) {
  .footer-component {
    width: 100%;
    font-size: 14px;
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
  }
  .footer-content p{
    font-size: 14px;
  }
}

/* 手机端样式 */
@media (max-width: 768px) {
  .footer-component {
    width: 100%;
    font-size: 10px;
    position: relative;
    bottom: 0;
    left: 0;
  }
}
</style>